import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CertPeriodRangeCalcDTO } from '@core/model';
import moment from 'moment';

interface CertPeriodWithLabel {
  label: string;
  value: CertPeriodRangeCalcDTO;
}

@Component({
    selector: 'app-cert-period-select',
    templateUrl: './cert-period-select.component.html',
    styleUrls: ['./cert-period-select.component.scss'],
    standalone: false
})
export class CertPeriodSelectComponent implements OnChanges {
  @Input() visible: boolean;
  @Input() certPeriods: CertPeriodRangeCalcDTO[];

  @Output() certPeriodSelected: EventEmitter<CertPeriodRangeCalcDTO> = new EventEmitter<CertPeriodRangeCalcDTO>();
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  mappedCertPeriods: CertPeriodWithLabel[];
  selectedCertPeriod: CertPeriodRangeCalcDTO;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.certPeriods?.currentValue) {
      this.mapCertPeriods(changes.certPeriods.currentValue);
    }
  }

  selectCertPeriod() {
    this.certPeriodSelected.emit(this.selectedCertPeriod);
    this.visibleChange.emit(false);
  }

  private mapCertPeriods(certPeriods: CertPeriodRangeCalcDTO[]) {
    this.mappedCertPeriods = certPeriods.map((period) => ({
      label: `${this.formatDate(period.effectiveFromDate)} - ${this.formatDate(period.effectiveToDate)}`,
      value: period,
    }));
  }

  private formatDate(date: string) {
    return moment(date).hours(0).format('L');
  }
}
